import axios from "axios";
const BASE = "micro-fire-alerts";

export default {
  async getSupported() {
    try {
      const { data } = await axios.get(`${BASE}/supported`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async generatePolygon(payload) {
    try {
      const { data } = await axios.post(`${BASE}/polygon`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async generateCircular(payload) {
    try {
      const { data } = await axios.post(`${BASE}/circular`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },
};
